export enum ExtLibEndpoint {
    HLSJS_GZIP_CDN = '//cdnjs.cloudflare.com/ajax/libs/hls.js/{{VERSION}}/hls.min.js',
    SHAKA_GZIP_CDN = '//cdnjs.cloudflare.com/ajax/libs/shaka-player/{{VERSION}}/shaka-player.compiled{{DEBUG}}.js',
    /** 
     * @deprecated
     */
    TWITCH_GZIP_CDN = '//player.live-video.net/{{VERSION}}/amazon-ivs-player.min.js',
}
